module.exports = "./images/Ref-Images-breit.jpg";